(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!window.__giftMessageDefined) {
    window.__giftMessageDefined = true;

    class GiftMessage extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.wrap = this.querySelector('.gift-message__wrap');
        this.textarea = this.querySelector('textarea');
        this.counter = this.querySelector('.gift-message__count');

        this.checkbox.addEventListener('change', (event) => {
          event.stopPropagation();
          this.wrap.classList.toggle('open', this.checkbox.checked);
          this.updateCart();
        });

        // Fallback defensivo: si "debounce" aun no estuviera disponible por
        // algun motivo de orden de carga, no rompemos el listener del textarea.
        const debounceFn = typeof debounce === 'function' ? debounce : (fn) => fn;

        this.textarea.addEventListener('input', (event) => {
          event.stopPropagation();
        });

        this.textarea.addEventListener(
          'input',
          debounceFn(() => {
            if (this.counter) {
              this.counter.textContent = `${this.textarea.value.length}/200`;
            }
            this.updateCart();
          }, 300)
        );
      }

      updateCart() {
        const body = JSON.stringify({
          attributes: {
            'Es un regalo': this.checkbox.checked ? 'Sí' : '',
            'Mensaje de regalo': this.textarea.value,
          },
        });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }
    }

    customElements.define('gift-message', GiftMessage);
  }
  } catch(e) { console.error(e); }
})();

})();
